// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const RotateRightOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M19.93 11a7.9 7.9 0 00-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM11 1v3.07a8 8 0 000 15.86v-2.02a6 6 0 010-11.82V10l4.55-4.45L11 1zm4.46 15.87c-.75.54-1.59.89-2.46 1.03v2.02a7.92 7.92 0 003.9-1.61l-1.44-1.44zm2.85.02A7.9 7.9 0 0019.93 13h-2.02a5.9 5.9 0 01-1.02 2.48l1.42 1.41z","fill":"currentColor"}}]},"name":"rotate-right","theme":"outlined"};

const RotateRightOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={RotateRightOutlinedSvg} />;
  RotateRightOutlined.displayName = 'RotateRightOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(RotateRightOutlined);
